module.exports = __webpack_public_path__ + "ClinicaPro-Regular-webfont.5fd1df19d4861daf49e3.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/ClinicaPro-Regular-webfont.svg
// module id = ../../../../../src/assets/fonts/ClinicaPro-Regular-webfont.svg
// module chunks = styles